import { expiredDiscountKey, useGlobalState } from '@libs/client'
import { useEventListener } from '@ui/hooks'
import { useRef } from 'react'
import css from 'styled-jsx/css'

const ExpiredDiscount = () => {
  const [, setIsExpiredDiscount] = useGlobalState<boolean>(expiredDiscountKey)

  const firstMounted = useRef(0)
  useEventListener({
    type: 'scroll',
    listener: () => {
      if (!!firstMounted.current && firstMounted.current !== window.pageYOffset) {
        setIsExpiredDiscount(false)
      }
      firstMounted.current = window.pageYOffset
    },
    options: { passive: true },
    element: typeof document !== 'undefined' ? document : undefined
  })

  return (
    <div className="ex-dsc">
      <style jsx global>
        {globalStyle}
      </style>
      <div className="ex-dsc__no-dsc-sellpage">
        Your discount code has expired...Check out our bestsellers for the latest deals!
      </div>
    </div>
  )
}

const globalStyle = css.global`
  .ex-dsc {
    position: fixed;
    top: 0;
    z-index: 100;
    background: #ffffff;
    width: 100%;

    &__has-dsc-sellpage {
      font-weight: 600;
      font-size: 15px;
      line-height: 24px;
      background: #e8f5e9;
      padding: 10px 16px 14px;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;

      &--expired {
        font-weight: 600;
        font-size: 18px;
        line-height: 26px;
        padding-bottom: 2px;
      }

      &--user {
        font-weight: 400;
        font-size: 15px;
        line-height: 24px;
        padding-bottom: 8px;
      }
      &--value {
        background: #ffffff;
        border: 2px dashed #388e3c;
        border-radius: 6px;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        color: #388e3c;
        width: 100%;
        padding: 6px 16px;

        @media screen and (min-width: 768px) {
          max-width: 342px;
          margin: auto;
        }
      }
    }

    &__no-dsc-sellpage {
      font-weight: 600;
      font-size: 15px;
      line-height: 24px;
      background: #fff3e0;
      padding: 16px;
      text-align: center;
    }
  }
`

export default ExpiredDiscount
